/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsPublicBarberOutput } from "../../entities/models/PublicBarberOutput";
import { z } from "zod/v4";

export const modelsPublicBarberOutputSchema = z.object({
    "avatar_url": z.optional(z.string()),
"can_cut_children": z.optional(z.boolean()),
"current_status": z.optional(z.string()),
"id": z.optional(z.int()),
"name": z.optional(z.string()),
"nearest_appointment_time": z.optional(z.string()),
"total_haircut": z.optional(z.int())
    }) as unknown as z.ZodType<ModelsPublicBarberOutput>